module.exports = __webpack_public_path__ + "assets/img/d5a9640230e23f834ba173b75c3fdb5c.png";